import { render } from "./FooterNav.vue?vue&type=template&id=8b63d0e6"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/scheduler/scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__